"use strict";
/**
 * Locale constants — single source of truth for short↔full locale mapping
 * Used across all frontends and backends
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHORT_TO_LOCALE = exports.DEFAULT_LOCALE = exports.SUPPORTED_LOCALES = void 0;
exports.shortToLocale = shortToLocale;
exports.isSupportedLocale = isSupportedLocale;
exports.parseAcceptLanguage = parseAcceptLanguage;
/** Full locale codes supported by backend translation systems */
exports.SUPPORTED_LOCALES = ['es-AR', 'en-US', 'pt-BR'];
exports.DEFAULT_LOCALE = 'es-AR';
/**
 * Map short language codes (used in frontends, user DB) to full locale codes (used in backend APIs)
 *
 * Frontend i18n uses short codes: 'es', 'en', 'pt', 'ru'
 * Backend APIs expect full locales: 'es-AR', 'en-US', 'pt-BR'
 * This map bridges the two formats.
 */
exports.SHORT_TO_LOCALE = {
    es: 'es-AR',
    en: 'en-US',
    pt: 'pt-BR',
    ru: 'es-AR', // Russian not yet supported in backend translations; falls back to Spanish
};
/**
 * Convert a short language code (or full locale) to the canonical full locale.
 * Handles: 'en' → 'en-US', 'pt-BR' → 'pt-BR', 'en-US' → 'en-US', 'xyz' → 'es-AR'
 */
function shortToLocale(code) {
    return exports.SHORT_TO_LOCALE[code.split('-')[0]?.toLowerCase()] || exports.DEFAULT_LOCALE;
}
/**
 * Check if a string is a supported full locale code
 */
function isSupportedLocale(code) {
    return exports.SUPPORTED_LOCALES.includes(code);
}
/**
 * Parse Accept-Language header to a supported locale code.
 * Supports: "es-AR", "en", "pt-BR;q=1.0", "en-US,es-AR;q=0.9"
 */
function parseAcceptLanguage(header) {
    if (!header)
        return exports.DEFAULT_LOCALE;
    const primaryLangWithQuality = header.split(',')[0]?.trim();
    const primaryLang = primaryLangWithQuality?.split(';')[0]?.trim();
    if (!primaryLang)
        return exports.DEFAULT_LOCALE;
    // Exact match (e.g., "en-US", "es-AR")
    if (isSupportedLocale(primaryLang)) {
        return primaryLang;
    }
    // Short code fallback (e.g., "en" → "en-US")
    const short = primaryLang.split('-')[0]?.toLowerCase();
    if (short && exports.SHORT_TO_LOCALE[short]) {
        return exports.SHORT_TO_LOCALE[short];
    }
    return exports.DEFAULT_LOCALE;
}
